import { render, staticRenderFns } from "./СitationTab.vue?vue&type=template&id=3d6b78c6&"
import script from "./СitationTab.vue?vue&type=script&lang=js&"
export * from "./СitationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports